export default{
    InbotInvoicesTitle: 'Hoá đơn đầu vào'
}